import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Base, BaseType as BaseType_ } from '../common/base-component';
import userManager from '../../utils/userManager';
import RedirectPage from './redirect';
import { AppState as AppState_ } from '../../redux/app-state';

type LogoutProps = {
} & BaseType_

export class Logout extends Base<LogoutProps, {}> {
  constructor(props) {
    super(props);

    const { match: { params: { autologout, }, }, } = this.props;
    const pars = !autologout ? {} : { AutoLogout: autologout, };

    userManager.signoutRedirect({ extraQueryParams: pars, });
  }

  content = () => {
    return (
      <RedirectPage />
    );
  }
}

export default withRouter(connect(
  (state: AppState_) => ({ ...state, })
)(Logout));
